var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsOptional, IsString, IsUUID, Matches } from 'class-validator';
import { AbsenceReason } from '../../enums/absence-reason.enum.js';
export class CreateAbsenceDto {
    userId;
    startDate;
    endDate;
    reason;
    note;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateAbsenceDto.prototype, "userId", void 0);
__decorate([
    IsString(),
    Matches(/^\d{4}-\d{2}-\d{2}$/, { message: 'startDate must be in "YYYY-MM-DD" format' }),
    __metadata("design:type", String)
], CreateAbsenceDto.prototype, "startDate", void 0);
__decorate([
    IsString(),
    Matches(/^\d{4}-\d{2}-\d{2}$/, { message: 'endDate must be in "YYYY-MM-DD" format' }),
    __metadata("design:type", String)
], CreateAbsenceDto.prototype, "endDate", void 0);
__decorate([
    IsEnum(AbsenceReason),
    __metadata("design:type", String)
], CreateAbsenceDto.prototype, "reason", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], CreateAbsenceDto.prototype, "note", void 0);
//# sourceMappingURL=create-absence.dto.js.map